import React, { useState } from "react";
import Navbar from "../../components/Navbar/Navbar";
import "./Admin.css";
import { httpsCallable } from "firebase/functions";
import { functions } from "../../utils/Firebase-Config";

function Admin() {
  const [name, setName] = useState("");
  const [description, setDescription] = useState("");
  const [price, setPrice] = useState("");
  const [interval, setInterval] = useState("month");
  
  // New schema fields matching our tier breakdown
  const [maxSites, setMaxSites] = useState("1");
  const [maxPortfolios, setMaxPortfolios] = useState("5");
  const [logRetentionDays, setLogRetentionDays] = useState("30");
  const [storageLimitGb, setStorageLimitGb] = useState("2");
  const [features, setFeatures] = useState(""); // Comma-separated
  const [hasEvidenceTrail, setHasEvidenceTrail] = useState(false);
  const [hasBrandedReports, setHasBrandedReports] = useState(false);
  
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    const fn = httpsCallable(functions, "createMvelioPlan");
    try {
      const result = await fn({
        name,
        description,
        amount: parseFloat(price),
        interval,
        // Passing the limits and features matching the new schema
        limits: {
          maxSites: parseInt(maxSites, 10),
          maxPortfolios: parseInt(maxPortfolios, 10),
          logRetentionDays: parseInt(logRetentionDays, 10),
          storageLimitGbPerPortfolio: parseFloat(storageLimitGb)
        },
        features: features.split(",").map(f => f.trim()).filter(Boolean),
        hasEvidenceTrail,
        hasBrandedReports
      });
      alert(`Success! Plan registered with Price ID: ${result.data.priceId}`);
      
      // Reset form fields
      setName("");
      setDescription("");
      setPrice("");
      setFeatures("");
      setHasEvidenceTrail(false);
      setHasBrandedReports(false);
    } catch (err) {
      console.error(err);
      alert("Admin action failed: " + err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="admin-layout">
      <Navbar />
      <form id="mvelio-admin-plan-form" className="admin-plan-form" onSubmit={handleSubmit}>
        <h3>Create New Mvelio Subscription Plan</h3>
        
        {/* Basic Info */}
        <input type="text" placeholder="Plan Name (e.g. Pro)" value={name} onChange={(e) => setName(e.target.value)} required />
        <input type="text" placeholder="Brief Description" value={description} onChange={(e) => setDescription(e.target.value)} required />
        <input type="number" placeholder="Monthly Price (USD)" value={price} onChange={(e) => setPrice(e.target.value)} required />
        <select value={interval} onChange={(e) => setInterval(e.target.value)}>
          <option value="month">Monthly</option>
          <option value="year">Yearly</option>
        </select>

        {/* New Limits & Features Section */}
        <h4>Tier Limits & Schema Config</h4>
        <div className="form-group">
          <label>Max Protected Sites</label>
          <input type="number" value={maxSites} onChange={(e) => setMaxSites(e.target.value)} required />
        </div>
        <div className="form-group">
          <label>Max Portfolios (Per Client)</label>
          <input type="number" value={maxPortfolios} onChange={(e) => setMaxPortfolios(e.target.value)} required />
        </div>
        <div className="form-group">
          <label>Log Retention (Days)</label>
          <input type="number" value={logRetentionDays} onChange={(e) => setLogRetentionDays(e.target.value)} required />
        </div>
        <div className="form-group">
          <label>Storage Limit per Portfolio (GB)</label>
          <input type="number" step="0.1" value={storageLimitGb} onChange={(e) => setStorageLimitGb(e.target.value)} required />
        </div>
        <input type="text" placeholder="Features (comma separated list)" value={features} onChange={(e) => setFeatures(e.target.value)} />

        {/* Feature Toggles */}
        <div className="checkbox-group">
          <label>
            <input type="checkbox" checked={hasEvidenceTrail} onChange={(e) => setHasEvidenceTrail(e.target.checked)} />
            Enable Downloadable Evidence Trail
          </label>
        </div>
        <div className="checkbox-group">
          <label>
            <input type="checkbox" checked={hasBrandedReports} onChange={(e) => setHasBrandedReports(e.target.checked)} />
            Enable Automated Branded Weekly Reports
          </label>
        </div>

        <button type="submit" disabled={loading}>
          {loading ? "Publishing..." : "Publish to Stripe & Firestore"}
        </button>
      </form>
    </div>
  );
}

export default Admin;
